export const parseSavedBoolean = (value, fallback = false) => {
  if (value === true || value === 1 || value === "1") return true;
  if (value === false || value === 0 || value === "0") return false;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
  }
  return fallback;
};

export const normalizeHiddenColumns = ({
  savedState = {},
  validColumnKeys = [],
  fallbackHiddenColumns = [],
}) => {
  const validKeySet = new Set((Array.isArray(validColumnKeys) ? validColumnKeys : []).map(String).filter(Boolean));
  if (!validKeySet.size) return [];

  let nextHiddenColumns = [];
  if (Array.isArray(savedState?.hiddenColumns)) {
    nextHiddenColumns = savedState.hiddenColumns.map(String).filter((key) => validKeySet.has(key));
  } else if (Array.isArray(savedState?.visibleCols) && savedState.visibleCols.length) {
    const visibleSet = new Set(savedState.visibleCols.map(String));
    nextHiddenColumns = Array.from(validKeySet).filter((key) => !visibleSet.has(key));
  }

  if (nextHiddenColumns.length >= validKeySet.size) {
    return Array.isArray(fallbackHiddenColumns) ? [...fallbackHiddenColumns] : [];
  }

  return nextHiddenColumns;
};
